import { render } from "./userInfo.vue?vue&type=template&id=95a261d6&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import "./userInfo.vue?vue&type=style&index=0&id=95a261d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95a261d6"

export default script